<template>
	<form action="" @submit.prevent="updateUser">
		<div class="col-lg-6">
			<label for="user-name-email">Username </label>
			<input
				type="text"
				id="user-name-email"
				class="text-field"
				placeholder="Username"
				v-model="UserDetails.name"
				required
			/>
		</div>
		<div class="col-lg-6 mt-4">
			<div class="form-group">
				<label for="user-name-email">Email </label>
				<input
					type="text"
					id="user-name-email"
					class="text-field"
					placeholder="Username"
					v-model="UserDetails.email"
					required
				/>
			</div>
		</div>
		<div class="col-lg-6 mt-4">
			<div class="form-group">
				<label for="user-phone-number">Phone Number </label>
				<input
					type="text"
					id="user-phone-number"
					class="text-field"
					placeholder="Phone Number"
					v-model="UserDetails.phone_no"
					required
				/>
			</div>
		</div>
		<div class="col-lg-6 mt-4">
			<div class="form-group">
				<label for="user-name-email">Profile Image</label>
				<input
					type="file"
					class="form-control"
					@change="updateImage"
					accept="image/png, image/jpeg, image/jpg"
				/>
			</div>
			<img
				style="width: 25%"
				:src="UserDetails.profile_photo_url"
				:alt="UserDetails.name"
				srcset=""
			/>
		</div>
		<div class="col-lg-6 mt-4">
			<div class="form-group">
				<label for="user-name-email">Address </label>

				<h6 class="account-h6 u-s-m-b-30" v-if="!UserDetails.address">
					Please click on button below to get location"
				</h6>

				<h6 class="account-h6 u-s-m-b-30" v-else>
					{{
						UserDetails.address
							? UserDetails.latitude +
							  ", " +
							  UserDetails.longitude +
							  ", " +
							  UserDetails.address
							: "Please click on button below to get location"
					}}
				</h6>

				<button
					type="button"
					class="button button-outline-secondary w-100"
					data-toggle="modal"
					data-target="#exampleModal"
				>
					{{ UserDetails.address ? "Change Location" : "Add Location" }}
				</button>
			</div>
		</div>
		<!-- <div class="col-lg-6 mt-4">
			<button class="button button-primary w-100">Change Password</button>
		</div> -->
		<div class="col-lg-6 mt-4">
			<button
				class="button button-primary w-100"
				:disabled="status.updateUser.loading"
			>
				{{ status.updateUser.loading ? "Please Wait.." : "Update" }}
			</button>
		</div>
	</form>
	<LocationModal @changeAddress="changeAddress" />
</template>

<script>
	import LocationModal from "./LocationModal.vue";
	import {mapActions, mapGetters} from "vuex";
	import {useToast} from "vue-toastification";
	export default {
		components: {LocationModal},
		data() {
			return {
				UserDetails: {
					name: "",
					address: "",
					latitude: "",
					longitude: "",
					phone_no: "",
					email: "",
					profile_photo_url: "",
				},
			};
		},
		computed: {
			...mapGetters("auth", ["user"]),
			...mapGetters("profile", ["status"]),
		},
		methods: {
			...mapActions("profile", ["updateUserDetail"]),
			updateUser() {
				// console.log(this.user.phone)
				this.updateUserDetail(this.UserDetails);
			},
			changeAddress(address) {
				(this.UserDetails.address = address.address),
					(this.UserDetails.longitude = address.lat),
					(this.UserDetails.latitude = address.lng);
			},
			updateImage(e) {
				const image = e.target.files[0];
				const reader = new FileReader();
				reader.readAsDataURL(image);
				reader.onload = (e) => {
					this.UserDetails.profile_photo_url = e.target.result;
				};
			},
		},
		mounted() {
			this.UserDetails = {
				...this.user.userdetails,
				name: this.user.name,
				email: this.user.email,
				profile_photo_url: this.user.profile_photo_url,
			};
		},
	};
</script>

<style scoped>
	input[type="text"] {
		border: 0.5px solid black;
	}
	.container form {
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
	}
</style>
